





































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import DateComponent from "@/components/common/Inputs/Date.vue";
import FormattedNumber from "@/components/common/Inputs/FormattedNumber.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import VCurrencyField from "@/components/common/CurrencyInput/VCurrencyField.vue";
import { Locales } from "@/i18n/locales";

const namespace: string = "migration";

@Component({
  components: {
    DateComponent,
    FormattedNumber,
    VCurrencyField
  },
})
export default class PersonnelTableComponent extends Vue {
  @Prop() header: any;
  @Prop() items: any;
  @Prop() currencyList: any;
  @Prop() currency: string;
  @Prop() formOptions: any;

  searchString = "";
  update = 0;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  editedItem: any = {
    rowId: undefined,
    empName: undefined,
    totCost: undefined,
    totCostEUR: undefined,
    budgetLine: undefined,
    hourlyRate: undefined,
    exchRate: undefined,
    grossSalary: undefined,
    costCharged: undefined,
    otherCost: undefined,
    currency: undefined,
    workHours: undefined,
    totalHours: undefined,
  };

  defaultItem: any = {
    rowId: undefined,
    empName: undefined,
    totCost: undefined,
    totCostEUR: undefined,
    budgetLine: undefined,
    hourlyRate: undefined,
    exchRate: undefined,
    grossSalary: undefined,
    costCharged: undefined,
    otherCost: undefined,
    currency: undefined,
    workHours: undefined,
    totalHours: undefined,
  };

  dialog = false;
  dialogDelete = false;
  editedIndex = -1;
  actions = _app.actions;
  subjects = _app.subjects;
  hasAuditPermission = false;
  includeFields = ["budgetLine"];

  close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  editItem(item) {
    this.editedIndex = this.items.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  findTotalCost(item) {
    if (item.grossSalary && item.otherCost) {
      item.totCost = item.grossSalary + item.otherCost;
    }
    this.$emit("input", true);
  }
  findTotCostEUR(item) {
    if (item.totCost && item.exchRate) {
      item.totCostEUR = item.totCost * item.exchRate;
    }
    this.$emit("input", true);
  }
  findHourlyRate(item) {
    if (item.totCostEUR && item.workHours) {
      if (item.workHours > 0) {
        item.hourlyRate = item.totCostEUR / item.workHours;
      }
    }
    this.$emit("input", true);
  }
  findCostCharged(item) {
    if (item.hourlyRate && item.totalHours) {
      item.costCharged = item.hourlyRate * item.totalHours;
    }
    this.$emit("input", true);
  }

  deleteItem(item) {
    this.editedIndex = this.items.indexOf(item);
    this.items.splice(this.editedIndex, 1);
    this.$emit("input", true);
    this.update += 1;
  }

  closeDelete() {
    this.dialogDelete = false;
  }

  // formatDate(dt: any) {
  //   return utils.formatDate(dt);
  // }

  numberFormat(val, precision) {
    return utils.formatDecimal(val, precision, this.defaultLocale);
  }

  addResult() {
    let obj = Object.assign({}, this.defaultItem);
    obj.rowId = utils.generateGUID();
    this.items.push(obj);
    this.$emit("input", true);
    this.update += 1;
  }

  currencyFormat(val, format) {
    return utils.formatCurrency(val, format, this.defaultLocale);
  }

  save() {
    if (this.editedIndex > -1) {
      Object.assign(this.items[this.editedIndex], this.editedItem);
    } else {
      this.items.push(this.editedItem);
    }
    this.close();
  }

  summary(key: any) {
    let sum = 0;
    if (this.items.length > 0) {
      this.items.map((row: any) => {
        sum += row[key] || 0;
      });
    }
    return sum;
  }
}
